(ns teamoesterreich.admin-mode.statistic.lebensretter-page
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.date :as h-date]          ;;(h/event-value e)
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.lr-statistic :as d-lrStatistic]
            ))

(defn wait-do-select [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" val)
      (event-fn val)
      (reset! !waiting? false)
      (reset! !loaded? false))))

(defn date-to-restDate [d]
  (let [t (clojure.string/replace (str (.toISOString d)) #"\.|:|-" "")]
    (str (subs t 0 15) "." (subs t 15))))

(defn get-list [!elms !loaded !invalidated !filter]
  (reset! !invalidated false)
  (d-lrStatistic/get-lr-statistic
    (or
      (:filter-organization @!filter)
      (:filter-organizationDepartment @!filter)
      (:filter-organizationMain @!filter)
      "....")


    (or (:filter-date @!filter) "")
    (fn [data]
      (reset! !elms (:elms data))
      (reset! !loaded true)
      )))






(defn dst-table []
  (let [
        !filter (r/cursor vstate/app-state [:lr-statistic :filter])
        !elms (r/cursor vstate/app-state [:lr-statistic :elms])
        !loaded? (r/cursor vstate/app-state [:lr-statistic :loaded])
        !waiting? (r/cursor vstate/app-state [:lr-statistic :waiting])
        !invalidated? (r/cursor vstate/app-state [:lr-statistic :invalidated])

        _ (d-organisation/get-store-organisations)
        !organisations (r/cursor vstate/app-state [:organisations])
        dep-mask-list (or (d-organisation/get-lv-filter-list @!organisations) [])
        dst-mask-list (reduce (fn [c [k m]] (assoc c k m)) {} (or (d-organisation/get-dest-list @!organisations) []))
        ]
    [mui/grid
     {:container     true
      :direction     "row"
      :alignItems    "stretch"
      :justify       "flex-start"
      :spacing       0
      :columnSpacing 0
      :style         {:flex "0 0 160px"}
      }
     [mui/grid
      {:item  true
       :xs    12
       :style {:minHeight "50px" :marginBottom "20px"}
       }
      [:h2 "Lebensretter Statistik"]
      ]
     (when (or (not @!loaded?)
               (true? @!invalidated?)) (get-list !elms !loaded? !invalidated? !filter) "")
     [mui/grid
      {:item  true
       :lg    6
       :xs    12
       :style {:minHeight "50px" :marginBottom "20px" :paddingRight "10px"}
       }
      [org-selector/get-selector !filter #(reset! !loaded? false) (d-rights/get-rights-orgId-filter d-rights/LEBENSRETTER)]
      ]
     [mui/grid
      {:item true
       :md   4
       :xs   10
       }
      [mui/text-field {
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :type            "date"
                       :autoOk          true
                       :format          "dd.MM.yyyy"
                       :label           (str "Stichtag")
                       :onChange        (wait-do-select !waiting? !loaded? (fn [val] (swap! !filter assoc :filter-date val)))
                       :defaultValue    (or (:filter-date @!filter)
                                            (h-date/print-format-g-date (h-date/now) "yyyy-MM-dd")
                                            )
                       }]
      ]
     [mui/grid
      {:item  true
       :xs    2
       :style {:height "50px" :text-align "right"}
       }
      [ws-event-sync-component/ws-event-reload !loaded? :lr-statistic]
      ]
     [mui/grid
      {:item  true
       :xs    12
       :style {:margin    "7px 0 0 0"
               :textAlign "left"}
       }
      (log/debug "statistic dst-table " (clj->js @!filter) (date-to-restDate (js/Date.)) (clj->js @!elms))
      [mui/table
       [mui/table-head
        [mui/table-row
         [mui/table-cell [:span (txt/txt :rights-level 2)]]
         [mui/table-cell [:span (txt/txt :rights-level 3)]]
         [mui/table-cell [:span "Anzahl TÖL"]]
         [mui/table-cell [:span "Anzahl TÖL aktiv"]]
         [mui/table-cell [:span "davon Sanitäter"]]
         [mui/table-cell [:span "davon Ärzte"]]
         [mui/table-cell [:span "davon Pflegedienst"]]
         [mui/table-cell [:span "davon Ersthelfer"]]
         [mui/table-cell [:span "Warten mit Doks"]]
         [mui/table-cell [:span "Warten ohne Doks"]]
         [mui/table-cell [:span "Summe zu " [:br] "bearbeiten"]]
         [mui/table-cell [:span "Laufen in 2 " [:br] " Monaten aus"]]
         ]]
       [mui/table-body
        (when @!elms
          (for [[key row] (or @!elms [])]
            (let []
              ^{:key (str "LR_ROW_-" key)}
              [mui/table-row
               [mui/table-cell (d-organisation/get-department-for-key (name key) dep-mask-list)]
               [mui/table-cell (or (get dst-mask-list (name key)) "-")]

               [mui/table-cell (:cnt-lr row)]
               [mui/table-cell (:lr-active row)]
               [mui/table-cell (:cnt-active-san row)]
               [mui/table-cell (:cnt-active-med row)]
               [mui/table-cell (:cnt-active-pfl row)]
               [mui/table-cell (- (:lr-active row) (+ (:cnt-active-san row) (:cnt-active-med row) (:cnt-active-pfl row)))]
               [mui/table-cell (:doc-waiting row)]
               [mui/table-cell (:doc-missing row)]
               [mui/table-cell (:cnt-lr row)]
               [mui/table-cell (:extendable row)]

               ])))
        ]

       ]
      [:br]]]
    ))


(defn get-it []
  (fn []
    (let [!filter (r/cursor vstate/app-state [:lr-statistic :filter])]
      [:div

       [mui/paper
        [dst-table]

        [:br]

        [mui/button {:style   {:verticalAlign "center" :margin "0px 0 7px 10px"}
                     :variant "outlined"
                     :onClick #(d-lrStatistic/get-lr-statistic-csv
                                 (or
                                   (:filter-organization @!filter)
                                   (:filter-organizationDepartment @!filter)
                                   (:filter-organizationMain @!filter)
                                   "....")
                                 (or (:filter-date @!filter) ""))
                     } "CSV"]
        ]

       ]
      )
    ))
